import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/shared/query/keys';
import { navWorkspaceAPI, type NavWorkspaceWrite } from './navWorkspace.api';

export const useNavWorkspaces = (enabled: boolean) => {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: queryKeys.navWorkspace.all,
    queryFn: () => navWorkspaceAPI.get(),
    enabled,
    staleTime: 60_000,
  });

  const save = useMutation({
    mutationFn: (payload: NavWorkspaceWrite) => navWorkspaceAPI.put(payload),
    onSuccess: (data) => {
      queryClient.setQueryData(queryKeys.navWorkspace.all, data);
    },
  });

  return { query, save };
};
